import * as Sentry from '@sentry/browser'

export const setSentryUser = (user) => {
  Sentry.configureScope((scope) => {
    scope.setUser(user)
  })
}

export const unsetSentryUser = () => {
  Sentry.configureScope((scope) => {
    scope.setUser(null)
  })
}

export const setSentryExtra = (data) => {
  Sentry.configureScope((scope) => {
    scope.setTags(data)
    scope.setExtras(data)
  })
}

export const unsetSentryExtra = (key) => {
  Sentry.configureScope((scope) => {
    scope.setTag(key, null)
    scope.setExtra(key, null)
  })
}



// WEBPACK FOOTER //
// ./src/lib/sentry.js